import { useRef } from "react";
import { useSelector, useDispatch } from "react-redux";

import DialogWrapper from "layouts/Flow Designer/components/Titlebar/components/DialogWrapper";
import CreateFlowVersionForm from "layouts/Flow Designer/components/Titlebar/components/CreateFlowVersionDialog/components/CreateFlowVersionForm";

import { setCreateFlowVersionDialogOpen } from "redux/actions/flowDesigner/flowsActionCreator";

const CreateFlowVersionDialog = () => {
  const { createFlowVersionDialogOpen, flowVersions, isFlowLoading } = useSelector(
    (state) => state.designer.flows
  );
  const formRef = useRef(null);
  const dispatch = useDispatch();

  const handleCloseCreateFlowVersionDialog = () => {
    dispatch(setCreateFlowVersionDialogOpen(false));
  };

  return (
    <DialogWrapper
      open={createFlowVersionDialogOpen}
      closeDialog={handleCloseCreateFlowVersionDialog}
      size="md"
      title="Create New Version"
      onSave={() => {
        formRef.current.submitForm();
      }}
      isLoading={isFlowLoading}
    >
      <CreateFlowVersionForm
        formRef={formRef}
        flowVersions={flowVersions}
        handleCloseDialog={handleCloseCreateFlowVersionDialog}
        isCreateFlowVersionDialog={true}
      />
    </DialogWrapper>
  );
};

export default CreateFlowVersionDialog;
